import React from 'react';

const StatBars = ({ stats }) => {
  const { hunger, energy, happiness } = stats;
  
  return (
    <div className="mt-6 space-y-4 px-2">
      <div>
        <div className="flex justify-between mb-1">
          <div className="flex items-center">
            <span className="text-sm font-pixel text-primary-300">HUNGER</span>
            <div className="relative ml-1 group">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-accent-400 cursor-help" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd" />
              </svg>
              <div className="absolute left-0 bottom-full mb-2 w-48 p-2 bg-dark-800 border border-primary-500 text-primary-300 text-xs font-mono rounded shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-opacity z-10">
                Represents note activity on the Nostr network. More notes = higher hunger satisfaction.
              </div>
            </div>
          </div>
          <span className="text-sm font-mono text-primary-300">{hunger}%</span>
        </div>
        <div className="stat-bar h-4 w-full bg-dark-800 border border-primary-700 rounded-sm overflow-hidden">
          <div 
            className="h-full bg-gradient-to-r from-primary-700 to-primary-500 pixel-corners"
            style={{ width: `${hunger}%` }}
          ></div>
        </div>
      </div>
      
      <div>
        <div className="flex justify-between mb-1">
          <div className="flex items-center">
            <span className="text-sm font-pixel text-accent-300">ENERGY</span>
            <div className="relative ml-1 group">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-accent-400 cursor-help" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd" />
              </svg>
              <div className="absolute left-0 bottom-full mb-2 w-48 p-2 bg-dark-800 border border-accent-500 text-accent-300 text-xs font-mono rounded shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-opacity z-10">
                Represents zap activity (tips) on the Nostr network. More zaps = higher energy.
              </div>
            </div>
          </div>
          <span className="text-sm font-mono text-accent-300">{energy}%</span>
        </div>
        <div className="stat-bar h-4 w-full bg-dark-800 border border-accent-700 rounded-sm overflow-hidden">
          <div 
            className="h-full bg-gradient-to-r from-accent-700 to-accent-500 pixel-corners"
            style={{ width: `${energy}%` }}
          ></div>
        </div>
      </div>
      
      <div>
        <div className="flex justify-between mb-1">
          <div className="flex items-center">
            <span className="text-sm font-pixel text-warning-300">HAPPINESS</span>
            <div className="relative ml-1 group">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-warning-400 cursor-help" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd" />
              </svg>
              <div className="absolute left-0 bottom-full mb-2 w-48 p-2 bg-dark-800 border border-warning-500 text-warning-300 text-xs font-mono rounded shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-opacity z-10">
                Represents Moscow Time (sats/USD). Rising Bitcoin price = higher happiness.
              </div>
            </div>
          </div>
          <span className="text-sm font-mono text-warning-300">{happiness}%</span>
        </div>
        <div className="stat-bar h-4 w-full bg-dark-800 border border-warning-700 rounded-sm overflow-hidden">
          <div 
            className="h-full bg-gradient-to-r from-warning-700 to-warning-500 pixel-corners"
            style={{ width: `${happiness}%` }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default StatBars; 